import { render, staticRenderFns } from "./TabsDashboardNetwork.vue?vue&type=template&id=4a74a809&"
import script from "./TabsDashboardNetwork.vue?vue&type=script&lang=js&"
export * from "./TabsDashboardNetwork.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports